import React, {useEffect, useState} from 'react'
import {Button, Col, Form, Row} from 'antd'
import {useTranslation} from "react-i18next"
import {useDispatch, useSelector} from "react-redux"
import CustomButton from "../../components/CustomButton"
import ObjectFuncTree from "./objectFuncTree"
import OjectAnalogTable from "./objectAnalogTable"
import api from "./store/api"
import {reRegionActions} from "../NRI/ReRegion/store/actions";
import {reZoneActions} from "../NRI/ReZone/store/actions";
import {buildTypesActions} from "../NRI/ReBuildType/store/actions";
import {referenceUnitActions} from "../NRI/ReReferenceUnits/store/actions";
import PtmList from "./CostBase/ptmList";
import {dAction} from "../../helpers/defaultAction";
import Notifications from "../../helpers/Notifications";
import PtmListResources from "./ResourceBase/ptmListResources";
import ConstructorForm from "./constructorForm";
import dayjs from "dayjs";
import 'dayjs/locale/ru';
import CircleLoading from "../../components/Loading/Circle";
import {globalActions} from "../../store/reducers/globalReducer";
import './style.css'

const style = {
    display: 'flex',
    justifyContent: 'end'
};

const initForm = {
    name: null,
    formationDate: null,
    month: null,
    regionId: null,
    zoneId: null,
    referenceUnitId: null,
    value: null,
    vat: false,
    buildTypeId: null,
    isResource: false,
    costIndex: 1
}

const initProject = {
    ptms: [], objects: []
}

const Constructor = (props) => {
    const {isResource, id, viewBlock, setViewBlock} = props
    const regions = useSelector(state => state.reRegionReducer.list)
    const zoneList = useSelector(state => state.reZoneReducer.list)
    const referenceUnits = useSelector(state => state.referenceUnitReducer.list)
    const buildTypes = useSelector(state => state.reBuildTypeReducer.list)
    const isLoading = useSelector(state => state.globalReducer.isLoading)
    const [state, setState] = useState()
    const [stateFuncType, setStateFuncType] = useState()
    const [funcVisible, setFuncVisible] = useState(false)
    const [project, setProject] = useState(initProject)
    const [formState, setFormState] = useState({...initForm, isResource: isResource})
    const [titleForTable, setTitleForTable] = useState({title: '', title2: '', data: ''})

    const [formVisible, setFormVisible] = useState(false)
    const {t} = useTranslation(['common', 'valid', 'kit', 'nri', 'action'])
    const dispatch = useDispatch()
    const [form] = Form.useForm()

    useEffect(() => {
        if (id) {
            getUserProject(id)
        }
        if (regions.length === 0) {
            dispatch(reRegionActions.getList())
        }
        if (zoneList.length === 0) {
            dispatch(reZoneActions.getList())
        }
        if (referenceUnits.length === 0) {
            dispatch(referenceUnitActions.getReferenceUnits())
        }
        if (buildTypes.length === 0) {
            dispatch(buildTypesActions.getBuildTypes())
        }
    }, [])

    useEffect(() => {
        form.setFieldsValue({
            objectFuncType: stateFuncType?.id
        })
    }, [stateFuncType])

    useEffect(_ => {
        if (formState.referenceUnitId) {
            if (referenceUnits) {
                const referenceUnit = referenceUnits.find(r => r.id === formState.referenceUnitId)
                if (referenceUnit) {
                    let customTitle
                    let name = referenceUnit.name
                    switch (referenceUnit.code) {
                        case(1):
                            customTitle = {title: t('common:power'), data: "power"}
                            name = t('kit:costUnitOfPower')
                            break;
                        case(2):
                        case(4):
                            customTitle = {title: t('common:totalArea'), data: "area"}
                            break;
                        case(3):
                        case(5):
                            customTitle = {title: t('common:reducedArea'), data: "area2"}
                            break;
                        case(6):
                            customTitle = {title: t('common:volume'), data: "value"}
                            break;
                    }
                    let title2 = `${t('common:cost')} на ${name}`
                    setTitleForTable({...customTitle, title2: title2})
                }
            }
        }
    }, [formState.referenceUnitId])

    function getUserProject(id) {
        dispatch(globalActions.setLoadingVisible(true))
        api.getUserProject(id)
            .then(res => {
                let initial = {
                    id: res.id,
                    name: res.name,
                    month: res.monthBuild,
                    year: res.yearBuild,
                    regionId: res.reRegionId,
                    zoneId: res.reZoneId,
                    referenceUnitId: res.reReferenceUnitId,
                    vat: res.vat,
                    value: res.value,
                    buildTypeId: res.reBuildTypeId,
                    isResource: res.isResource,
                    costIndex: res.costIndex
                }
                setFormState({
                    ...initial,
                    formationDate: dayjs(new Date(res.yearBuild, res.monthBuild - 1, 1))
                })
                let ptms = JSON.parse(res.ptms);
                let objects = JSON.parse(res.objects);
                ptms = ptms.map((el, idx) => ({key: `${el.obj}_${el.code}_${el.id}`, ...el}))
                objects = objects.map((el, idx) => ({key: `${el.id}`, ...el}))
                setState({
                    ...initial,
                    ptms: ptms,
                    objects: objects
                })//state используется только для сравнения на неизменность при сохранении редактируемого проекта
                setProject({ptms, objects})
            })
            .finally(() => dispatch(globalActions.setLoadingVisible(false)))
    }

    const create = params => {
        dispatch(dAction(api.create, params, saved, t('action:created')))
    }
    const edit = params => {
        dispatch(dAction(api.edit, params, edited, t('action:updated')))
    }
    const saved = (res, message) => {
        if (res === true) {
            Notifications.successNotice(message, '', 10)
            setProject(initProject)
            setStateFuncType(null)
            setFormState({...initForm})
        }
    }
    const edited = (res, message) => {
        if (res === true) {
            Notifications.successNotice(message, '', 10)
        }
    }

    const save = () => {
        const params = {
            id: formState.id,
            name: formState.name,
            month: formState.month,
            year: formState.year,
            regionId: formState.regionId,
            zoneId: formState.zoneId,
            referenceUnitId: formState.referenceUnitId,
            vat: formState.vat,
            value: formState.value,
            buildTypeId: formState.buildTypeId,
            isResource: formState.isResource,
            costIndex: formState.costIndex,
            ptms: project.ptms,
            objects: project.objects
        }
        if (id) {
            if (JSON.stringify(params) === JSON.stringify(state)) {
                Notifications.errorNotice(t('valid:sameData'), null, 10)
            } else {
                edit(params)
            }
        } else {
            create(params)
        }
    }

    function repeatBrick(numbers) {//от плиток отказались
        let items = [];
        for (let i = 0; i < numbers; i++) {
            let offset = 0
            if (i === 0) offset = 5
            items.push(<Col
                key={i}
                className="brick"
                offset={offset}
                span={3}
                onClick={() => {
                    setFormVisible(true)
                }}
            >
            </Col>);
        }
        return items
    }

    return (
        <>
            {viewBlock === "default" &&
                <>
                    {formState.value ? <>
                            <Row gutter={[16, 8]}>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('common:name')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.name}</div>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('kit:formationDate')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.formationDate?.format("MM.YYYY")}</div>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('common:region')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.regionId && regions?.find(n => n.id === formState.regionId)?.name}</div>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('common:zone')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.zoneId && zoneList?.find(n => n.id === formState.zoneId)?.name}</div>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('nri:referenceUnit')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.referenceUnitId && referenceUnits?.find(n => n.id === formState.referenceUnitId)?.name}</div>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('common:volume')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.value}</div>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('common:vat')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.vat != null && (formState.vat ? 'с налогом' : 'без налога')}</div>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('nri:buildType')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.buildTypeId && buildTypes?.find(n => n.id === formState.buildTypeId)?.name}</div>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('kit:cmp')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div>{formState.costIndex.toFixed(4)}</div>
                                </Col>
                                <Col offset={6} style={{paddingBottom: '10px'}}>
                                    <Button
                                        onClick={() => {
                                            setFormVisible(true)
                                        }}
                                    >
                                        {t('kit:changEntered')}
                                    </Button>
                                </Col>
                            </Row>
                            <Row gutter={[16, 0]}>
                                <Col className="gutter-row" span={6}>
                                    <div style={style}>{`${t('kit:funcPurpose')}:`}</div>
                                </Col>
                                <Col className="gutter-row" span={18} style={{paddingBottom: '10px'}}>
                                    <Button
                                        onClick={() => {
                                            setFuncVisible(true)
                                        }}
                                        //type = "grey"
                                        style={{marginRight: '20px', padding: '10px, 0'}}
                                    >
                                        {t('action:choice')}
                                    </Button>
                                    <span>{stateFuncType?.name}</span>
                                </Col>
                            </Row>
                        </>
                        :
                        <>
                            <Col className='fillCustomObj'>
                                <CustomButton
                                    type='blue'
                                    className={formState.value ? "" : "create_button"}
                                    onClick={() => {
                                        setFormVisible(true)
                                    }}
                                >
                                    {t('kit:fillCustomObj')}
                                </CustomButton>
                            </Col>
                            {/*<Col offset={5} span={18} style={{padding: '40px 0'}}>
                                <span style={{fontSize: '16px'}}>{t('kit:fillCustomObj')}</span>
                            </Col>
                            {[1, 2, 3, 4, 5, 6].map((n, index) => {
                                return <Row key={index}>{repeatBrick(n)}</Row>
                            })}*/}
                        </>
                    }
                    {isLoading && <CircleLoading/>}
                    <ConstructorForm
                        visible={formVisible}
                        setVisible={setFormVisible}
                        formState={formState}
                        setFormState={setFormState}
                        project={project}
                        setProject={setProject}
                        isResource={isResource}
                    />
                    {project.ptms.length > 0 && <>
                        {isResource ?
                            <PtmListResources
                                project={project}
                                setProject={setProject}
                                formState={formState}
                                titleForTable={titleForTable}
                            />
                            : <PtmList
                                project={project}
                                setProject={setProject}
                                formState={formState}
                            />
                        }
                        <Col style={{display: "flex", flexDirection: "column", alignItems: "end", marginBottom: "15px"}}>
                            <CustomButton
                                key="save"
                                //loading={loading}
                                type="green"
                                onClick={save}
                            >
                                {t('action:save')}
                            </CustomButton>
                        </Col>
                    </>
                    }
                </>
            }
            <ObjectFuncTree
                setStateFuncType={setStateFuncType}
                setVisible={setFuncVisible}
                visible={funcVisible}
            />
            {stateFuncType &&
                <OjectAnalogTable
                    formState={formState}
                    stateFuncType={stateFuncType}
                    project={project}
                    setProject={setProject}
                    viewBlock={viewBlock}
                    setViewBlock={setViewBlock}
                    titleForTable={titleForTable}
                />
            }
        </>
    )
}

export default Constructor
/*
<Form.Item
    label={t('common:zoneBuild')}
    name="zone"
>
    <Cascader
        className='custom-select'
        options={[
            {
                value: 1,
                label: 'Зона 1',
                children: cities.map((el, idx) => ({value: el.id, label: el.name}))
            },
            {
                value: 2,
                label: 'Зона 2',
                children: regions.filter(n => n.code !== 5).map((el) => ({
                    value: el.id,
                    label: el.name
                }))
            },
            {
                value: 3,
                label: 'Зона 3',
                children: regions.filter(n => n.code === 5).map((el) => ({
                    value: el.id,
                    label: el.name
                }))
            },
        ]}
        onChange={onChange}
    />
</Form.Item>*/
